/**
 * Formats a number as a currency string.
 * Example: 2500 -> "$2,500.00"
 */
export const formatCurrency = (amount) => {

    const value = amount || 0;
    return "$ " + value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
}